// This file is generated. Do not update manually!
import { Resource } from '../client/resource.js';
export class Subscriptions extends Resource {
    path = 'subscriptions';
    entity = 'subscription';
    /**
     * Set a user's subscription status to subscribed for a particular topic (and
     * optional categories). If the user previously unsubscribed, the user will be
     * resubscribed.
     *
     * @param data
     * @param options - override client request options.
     * @returns
     **/
    create(data, options) {
        return this.request({
            method: 'POST',
        }, data, options);
    }
    /**
     * Unusbscribe a user from a particular topic (and optional categories).
     *
     * @param topic - The topic for which we'd like to filter topic subscriptions.
     * @param data
     * @param options - override client request options.
     * @returns
     **/
    unsubscribe(topic, data, options) {
        return this.request({
            method: 'POST',
            path: '{topic}/unsubscribe',
        }, topic, data, options);
    }
    /**
     * Fetch a user's topic subscriptions.
     *
     * @param options - override client request options.
     * @returns
     **/
    list(options) {
        return this.request({
            method: 'GET',
            paged: true,
        }, options);
    }
    /**
     * Show a user's subscription status for a particular topic and categories.
     *
     * @param topic - The topic for which we'd like to filter topic subscriptions.
     * @param options - override client request options.
     * @returns
     **/
    get(topic, options) {
        return this.request({
            method: 'GET',
            path: '{topic}',
        }, topic, options);
    }
    delete(topic, dataOrOptions, options) {
        return this.request({
            method: 'DELETE',
            path: '{topic}',
        }, topic, dataOrOptions, options);
    }
}
//# sourceMappingURL=subscriptions.js.map